<div id="editor" #editor [attr.template-theme]="theme || DynamicTemplateThemeEnum.Modern" [class]="isMobile ? 'view--mobile' : 'view--desktop'" [style]="'transform: scale(' + scale + ');'"></div>
